<template lang="pug">
div
  v-layout.flex-column-phone(align-center, justify-space-between)
    h2 Berekenen

  v-tabs.mt-3(v-model='activeTab', slider-color='primary')
    v-tab.mr-4(key='businesslease', :to='{ name: "calculations business lease" }') Financial Lease (zakelijk)
    v-tab.mr-4(key='privatelease', :to='{ name: "calculations private lease" }') Krediet (particulier)
    v-tab(key='vkm', :to='{ name: "calculations vkm" }') Verantwoord Krediet Maximum (VKM)

  .calculations
    router-view
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'businesslease'
    }
  }
}
</script>

<style lang="scss" scoped>
.calculations {
  max-width: 700px;
}
</style>
